import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Text,
} from '@chakra-ui/react';
import { useDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useDeleteStore>;

export const ComponentDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteComponent,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">コンポーネントの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>コンポーネント名</FormLabel>
            <Input
              type="text"
              value={values.componentName}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormLabel>顧客環境に適用したい情報の定義</FormLabel>
          <Stack pl="5">
            <FormControl>
              <FormLabel>管理場所</FormLabel>
              <Input
                type="text"
                value={values.repositoryUrl}
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
          </Stack>
          <FormLabel>顧客環境から収集したい情報の定義</FormLabel>
          <Stack pl="5">
            <FormControl>
              <FormLabel>マニフェストファイル名</FormLabel>
              <Input
                type="text"
                value={values.manifestName}
                width="240px"
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
            <FormControl>
              <FormLabel>必要なキー</FormLabel>
              {values.targetKeys?.map((targetKey, index) => (
                <Stack key={index.toString()}>
                  <Input
                    type="text"
                    value={targetKey.value}
                    variant="flushed"
                    isReadOnly
                  />
                </Stack>
              ))}
            </FormControl>
          </Stack>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のコンポーネント情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteComponent} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
